/**
 * Auth0 Configuration for ClaimMosaic Agent
 * Shared configuration that works across all environments
 */

/**
 * Get Auth0 configuration based on current environment
 */
export function getAuth0Config() {
  const isLocalhost =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1");

  // Base configuration - same across all environments
  const baseConfig = {
    domain: "auth.claimmosaic.com",
    cacheLocation: "localstorage" as const
  };

  // Localhost (aligned with LocalQA)
  if (isLocalhost) {
    return {
      ...baseConfig,
      clientId: "fz5UcCPqwr2tctiYwAiK4k0WQdEzKgrX",
      authorizationParams: {
        audience: "https://localhost:5001",
        redirect_uri: "http://localhost:5173"
      }
      // No cookieDomain for localhost (each port is separate origin)
    };
  }

  // Detect QA vs Production by hostname
  const isQA =
    typeof window !== "undefined" && window.location.hostname.includes("qa");

  // QA Environment
  if (isQA) {
    return {
      ...baseConfig,
      clientId: "fz5UcCPqwr2tctiYwAiK4k0WQdEzKgrX",
      authorizationParams: {
        audience: "https://api-claimmosaic-qa.azurewebsites.net",
        redirect_uri: "https://agent-qa.claimmosaic.com/callback"
      },
      cookieDomain: ".claimmosaic.com"
    };
  }

  // Production Environment
  return {
    ...baseConfig,
    clientId: "2iqCLZsrLgCbDiHrcI1kR44Fk69qeldo",
    authorizationParams: {
      audience: "https://api.claimmosaic.com",
      redirect_uri: "https://agent.claimmosaic.com/callback"
    },
    cookieDomain: ".claimmosaic.com"
  };
}
